<template>
  <div :class="{ 'form-control': true, 'is-select': true }">
    <v-select
      :options="agents"
      v-model="agent_id"
      :reduce="agent => agent.id"
      :filterBy="filterByForAgents"
      :placeholder="$t('agents.selectAgent')"
      label="name"
      @search="debouncedFetchAgents">
      <template slot="no-options">
        <template v-if="!emptyResults">{{ $t('ui.searching') }}&hellip;</template>
        <template v-if="emptyResults">{{ $t('agents.noAgentsMatchingPhraseFound') }}&hellip;</template>
      </template>
      <template slot="option" slot-scope="option">
        <div class="d-center">
          {{ option.name }}
        </div>
      </template>
      <template slot="selected-option" slot-scope="option">
        <div class="selected d-center">
          {{ option.name }}
        </div>
      </template>
    </v-select>
  </div>
</template>

<script>
import debounce from 'lodash.debounce';
import FormUtils from './../../utils/FormUtils.js';

export default {
  name: 'select-agent',
  props: {
    agentID: {
      type: [String, Number]
    }
  },
  watch: {
    agent_id (newValue) {
      let agentName = '';

      if (newValue) {
        let foundedAgent = this.agents.filter(agent => agent.id === newValue);

        if (foundedAgent[0]) {
          agentName = foundedAgent[0].name;
        }
      }

      this.$bus.$emit('ui-select-agent-updated', {
        agentID: newValue,
        agentName
      });
    }
  },
  data () {
    return {
      agent_id: null,
      agents: [],
      emptyResults: false,
      loadAgentsError: false
    }
  },
  mounted () {
    this.endpointBase = '/agents';
    this.agent_id = this.agentID;

    if (this.agent_id) {
      this.prefetchAgent(this.agent_id);
    } else {
      this.agent_id = null;

      FormUtils.loadAdditionalData(this, {
        endpoint: this.endpointBase + '/items',
        outputKey: 'agents',
        errorKey: 'loadAgentsError'
      });
    }

    this.$bus.$on('ui-select-agent-reset', this.resetValue);
  },
  methods: {
    filterByForAgents (option, label, search) {
      return (option.name).toLowerCase().indexOf(search.toLowerCase()) > -1;
    },
    prefetchAgent (agentID) {
      if (!agentID) {
        return;
      }

      FormUtils.loadAdditionalData(this, {
        endpoint: this.endpointBase + '/item/' + parseInt(agentID, 10),
        outputKey: 'agents',
        errorKey: 'loadAgentsError',
        wrapResponseIntoArray: true,
        successAction: () => {
          this.agent_id = parseInt(agentID, 10);
        }
      });
    },
    fetchAgents (searchPhrase, loadingCallback) {
      this.emptyResults = false;
      loadingCallback(true);

      let endpointUrl = this.endpointBase + '/items';
      let responseAsArray = false;
      let paramsData = {};

      if (searchPhrase !== '') {
        paramsData.where = {
          search: searchPhrase
        };
      }

      if (this.agent_id !== 0 && this.agent_id !== null && searchPhrase === '') {
        endpointUrl = this.endpointBase + '/item/' + parseInt(this.agent_id, 10);
        responseAsArray = true;
      }

      FormUtils.loadAdditionalData(this, {
        endpoint: endpointUrl,
        outputKey: 'agents',
        errorKey: 'loadAgentsError',
        params: paramsData,
        wrapResponseIntoArray: responseAsArray,
        successAction: (response) => {
          if (!response.length) {
            this.emptyResults = true;
          }

          loadingCallback(false);
        }
      });
    },
    // eslint-disable-next-line
    debouncedFetchAgents: debounce(function (searchPhrase, loadingCallback) {
      this.fetchAgents(searchPhrase, loadingCallback);
    }, 500),
    resetValue () {
      this.agent_id = null;
    }
  },
  beforeDestroy () {
    this.$bus.$off('ui-select-agent-reset', this.resetValue);
  }
}
</script>

<style lang="scss" scoped>
.is-v-select-wrapper > div {
  width: 100%;
}
</style>
